<template>
  <div class="w-100">
    <div :class="classHeading"> {{ chartHeader }} </div>
    <div :class="className" :style="{height:height,width:width}" ref="pieChart"></div>
  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts/dist/echarts.js';
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
// require('echarts/theme/royal') // echarts theme

export default {
  props: {
    jsonData: {
      type: Object,
      default: function() { return {} }
    },
    legendData: {
      type: Array,
      default: function() { return ['Sponsor', 'Manager', 'Exco2', 'HRBP'] }
    },
    seriesData: {
      type: Array,
      default: function() { return [
              { value: 320, name: 'Sponsor' },
              { value: 240, name: 'Manager' },
              { value: 149, name: 'Exco2' },
              { value: 100, name: 'HRBP' },
            ] }
    },
    chartHeader: {
      type: String,
      default: ''
    },
    classHeading: {
      type: String,
      default: 'chartHeader'
    },
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    noClick: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '300px'
    }
  },
  data() {
    return {
      chart: null,
      $_sidebarElm: null,
      chartThemes : ['macarons', 'vintage', 'royal', 'green', 'shine', 'gray', 'inspired', 'jazz']
    }
  },
  watch: {
    seriesData() {
      this.$nextTick(() => {
        this.initChart()
      })
    }
  },
  methods: {
    initChart() {
      let theme = this.chartThemes[Math.floor(Math.random() * this.chartThemes.length)]
      console.log('random index val-> ', theme )
      console.log('random index val-> ', echarts )
      this.chart = echarts.init(this.$refs.pieChart, this.chartThemes[theme])

      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          left: 'center',
          bottom: '10',
          data: this.legendData
        },
        series: [
          {
            name: 'Nominations',
            type: 'pie',
            roseType: 'angle',
            radius: [15, 95],
            center: ['50%', '38%'],
            data: this.seriesData,
            animationEasing: 'cubicInOut',
            animationDuration: 2600
          }
        ]
      })
      var self = this
      if (this.noClick)
      this.chart.on('click', function(params){
        console.log('PIECHART click params condtn-> ', (params.name && self.jsonData))
        console.log('PIECHART click params-> ', params)
        console.log('PIECHART click params json-> ', self.jsonData)
        console.log('PIECHART click params case-> ', self.jsonData[params.name.toLowerCase()])
        if (params.name === "High5")
          location.href= WordpressRestURI.frontEndDomain + "report-ve-awards?cat=102"
        else if (params.name === "On the Spot")
          location.href= WordpressRestURI.frontEndDomain + "report-ve-awards?cat=103"
        else if (params.name === "Teams")
          location.href= WordpressRestURI.frontEndDomain + "report-ve-awards?cat=104"
        else if (params.name && self.jsonData) {
      console.log('PIECHART click params case join-> ', self.jsonData[params.name.toLowerCase()].join('&include[]='))
          // Handle Pending Nominators PIE CHART
          let nIds = 'include[]=' + self.jsonData[params.name.toLowerCase()].join('&include[]=')
          localStorage.setItem('paramName', params.name)
          localStorage.setItem('paramCount', params.value)
          localStorage.setItem('paramIds', nIds)
          location.href= WordpressRestURI.frontEndDomain + 'report-dashboard/' + params.name
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PieChart.vue